import { Injectable } from '@angular/core';
import {
  TrackedActionModel,
  TrackedActionCodes,
  QuoteModel,
  PrototypeModel,
} from '@cpak/adp-cpak-quotes-service-models';
import { UserModel } from '@cpak/adp-cpak-users-service-models';
import { QuotePageData } from '@cpak/adp-cpak-bff-service-models';
import { getTrackedActionsListForCurrentQuote } from '@cpak/shared/utils';

@Injectable({ providedIn: 'root' })
export class QuoteService {
  public getAction(
    trackedActionsList: TrackedActionModel[],
    actionCode: TrackedActionCodes
  ): TrackedActionModel | undefined {
    return trackedActionsList.find(action => action.code === actionCode);
  }

  private getCreatedActions(trackedActionsList: TrackedActionModel[]): TrackedActionModel | undefined {
    return this.getAction(trackedActionsList, TrackedActionCodes.QuoteCreated);
  }

  public getUserById(users: UserModel[], userId: string): UserModel | undefined {
    return users.find((user: UserModel) => user.id === userId);
  }

  public createdBy(quoteData: QuotePageData, quote?: QuoteModel | PrototypeModel): UserModel | undefined {
    const actionList = getTrackedActionsListForCurrentQuote(quoteData, quote);
    const createdAction = this.getCreatedActions(actionList);
    if (createdAction) {
      return this.getUserById(quoteData.users, createdAction.userId || '');
    }
    return undefined;
  }
}
